<template>
    <div id="content">
        <loader></loader>
        <div class="top">
            <div class="header">
                <h1>Questionnaires <span v-if="customerId">- {{customer.company}}</span></h1>
                <div class="pageOptions">
                    <btn text="Ajouter" ico="add" @click="add()"
                         v-if="$store.getters.hasPerm('questionnaire:add/edit')"></btn>
                </div>
            </div>
            <div class="options" v-if="!customerId">
                <div class="searchBar drop">
                    <multi-list-select
                            :list="customers"
                            :selectedItems="customersSelect"
                            option-value="id"
                            option-text="company"
                            placeholder="Sélectionner un client"
                            @select="onSelectCustomer">
                    </multi-list-select>
                </div>
                <div class="searchBar drop">
                    <multi-list-select
                            :list="reasons"
                            :selectedItems="reasonsSelect"
                            option-value="id"
                            option-text="label"
                            placeholder="Sélectionner un motif"
                            @select="onSelectReason">
                    </multi-list-select>
                </div>
                <btn ico="times" color="red" @click="resetSearch"></btn>
            </div>
            <search-bar v-else @search="search" :value="filter"></search-bar>
        </div>
        <div class="table-responsive">
            <table>
                <thead>
                <tr>
                    <th v-if="!customerId">
                        Client
                        <table-order name="customer_id" @change="changeOrder"></table-order>
                    </th>
                    <th>
                        Titre
                        <table-order name="label" @change="changeOrder"></table-order>
                    </th>
                    <th>
                        Motif d'appel
                        <table-order name="reason.label" @change="changeOrder"></table-order>
                    </th>
                    <th>
                        Etat
                        <table-order name="etat" @change="changeOrder"></table-order>
                    </th>
                    <th>
                        Dernière modif.
                        <table-order name="updateAt" @change="changeOrder"></table-order>
                    </th>
                    <th>
                        Date de création
                        <table-order name="createAt" @change="changeOrder"></table-order>
                    </th>
                    <th>
                        Options
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(questionnaire, key) in visibles">
                    <td v-if="!customerId">{{questionnaire.customer.company}}</td>
                    <td>{{questionnaire.label}}</td>
                    <td>{{questionnaire.reason.label}}</td>
                    <td>{{state(questionnaire.state)}}</td>
                    <td>{{questionnaire.updateAt|formatDateHour}}</td>
                    <td>{{questionnaire.createAt|formatDateHour}}</td>
                    <td class="tableOptions">
                        <div @click="list(questionnaire)"
                             v-if="$store.getters.hasPerm('responses:list') && questionnaire.state === '1'"
                             title="Afficher les réponses">
                            <svg class="option">
                                <use xlink:href="#icon-list"></use>
                            </svg>
                        </div>
                        <div @click="edit(questionnaire)"
                             v-if="$store.getters.hasPerm('questionnaire:add/edit') && questionnaire.state === '-1'"
                             title="Modifier le questionnaire">
                            <svg class="option">
                                <use xlink:href="#icon-edit"></use>
                            </svg>
                        </div>
                        <div @click="show(questionnaire)"
                             v-if="$store.getters.hasPerm('questionnaire:add/edit') && questionnaire.state === '1'"
                             title="Afficher le questionnaire">
                            <svg class="option">
                                <use xlink:href="#icon-eye"></use>
                            </svg>
                        </div>
                        <div @click="copy(questionnaire)" v-if="$store.getters.hasPerm('questionnaire:copy')"
                             title="Dupliquer le questionnaire">
                            <svg class="option">
                                <use xlink:href="#icon-copy"></use>
                            </svg>
                        </div>
                        <div @click="del(questionnaire)"
                             v-if="$store.getters.hasPerm('questionnaire:del') && questionnaire.state === '-1'"
                             title="Supprimer le questionnaire en brouillon">
                            <svg class="option">
                                <use xlink:href="#icon-delete"></use>
                            </svg>
                        </div>
                        <label class="switch"
                               v-if="$store.getters.hasPerm('questionnaire:add/edit') && questionnaire.state === '1'">
                            <input type="checkbox" @change="active(questionnaire, $event)"
                                   :checked="questionnaire.active === '1'">
                            <span class="slider"></span>
                        </label>
                    </td>
                </tr>
                <tr v-if="visibles.length <= 0">
                    <td :colspan="customerId > 0 ? 5 : 6" style="text-align: center">Il n'y a aucun questionnaire pour
                        ce client
                    </td>
                </tr>
                </tbody>
            </table>
            <pagination :current="currentPage" :limit="limit" :array="filters" @change="pageChange"
                        @limitChange="limitChange"></pagination>
        </div>
    </div>

</template>

<script>

    import SearchBar from "@/components/SearchBar";
    import Pagination from "@/components/Pagination";
    import Loader from "@/components/Loader";
    import TableOrder from "@/components/TableOrder";
    import axios from 'axios';
    import tools from '../config.ts';
    import Btn from "@/components/Btn";
    import MultiListSelect from "vue-search-select/src/lib/MultiListSelect";

    export default {
        name: "Questionnaires",
        components: {Btn, Pagination, SearchBar, Loader, TableOrder, MultiListSelect},
        data() {
            return {
                currentPage: 0,
                limit: 100,
                filter: "",
                order: {
                    order: 'desc',
                    name: 'createAt',
                },

                questionnaires: [],
                customer: {},

                customers: [],
                reasons: [],
                customersSelect: [],
                reasonsSelect: [],

                customerId: 0,

                locals: ["currentPage", "filter", "order","customersSelect","reasonsSelect"],
                cookies: ["limit"],
                timeOut: 0,
            }
        },
        methods: {
            loadByCustomer() {

                axios.get(tools.api("customer/" + this.customerId), tools.headerGET())
                    .then((response) => {
                        this.customer = response.data;

                    });

                axios.get(tools.api("customer/" + this.customerId + "/questionnaires"), tools.headerGET())
                    .then((response) => {

                        this.questionnaires = response.data;

                        tools.loader(false);
                        tools.saveLocals("questionnaires", this);
                    })
                    .catch((e) => {
                        tools.loader(false)
                    })

            },
            loadAll() {

                axios.get(tools.api("questionnaires"), tools.headerGET())
                    .then((response) => {
                        this.questionnaires = response.data;

                        tools.loader(false);
                        tools.saveLocals("questionnaires", this);
                    })
                    .catch((e) => {
                        tools.loader(false)
                    })


                axios.get(tools.api("customers"), tools.headerGET())
                    .then(response => {
                        this.customers = response.data;
                    });

                // reasons load for search bar
                axios.get(tools.api("reasons"), tools.headerGET())
                    .then(response => {
                        this.reasons = response.data;
                    });
            },
            add() {
                let customerId = this.customerId;
                if (!this.customerId) {
                    customerId = 0
                }
                this.$router.push("/customer/" + customerId + "/questionnaire/edit")
            },
            edit(questionnaire) {
                this.$router.push("questionnaire/" + questionnaire.id + "/edit")
            },
            response(questionnaire) {
                this.$router.push("questionnaire/" + questionnaire.id + "/response")
            },
            list(questionnaire) {
                this.$router.push("/customer/" + questionnaire.customer_id + "/questionnaire/" + questionnaire.id + "/responses")
            },
            copy(questionnaire) {
                tools.popup("confirm", {
                    title: "Confirmation",
                    message: "Comment voulez-vous dupliquer ce questionnaire ?",
                    btn:["Avec client","none","Sans client"],
                    success: () => {

                        this.copyValid(questionnaire,questionnaire.customer_id);
                    },
                    successSecond: () => {

                        this.copyValid(questionnaire,0);
                    }
                })
            },
            copyValid(questionnaire,customer){

                tools.loader(true);

                let url = "questionnaire/" + questionnaire.id + "/copy/customer/"+customer;

                axios.get(tools.api(url), tools.headerGET())
                    .then((response) => {
                        if (!tools.isSuccessResponse(response)) {
                            return tools.popup("valid", {
                                title: "Erreur",
                                message: "Erreur lors de la duplication du questionnaire",
                            });
                        }

                        this.$router.push("/customer/" + customer + "/questionnaire/" + response.data.questionnaire_id + "/edit")
                    })
                    .catch((error) => {
                        tools.loader(false);
                        tools.popup("valid", {
                            title: "Erreur",
                            message: "Erreur lors de la duplication du questionnaire. <br/><br/>Détail de l'erreur : <br/>" + tools.parseError(error)
                        })
                    })

            },
            show(questionnaireId) {
                this.$router.push("questionnaire/" + questionnaireId + "/show")
            },
            del(questionnaire) {

                tools.popup("confirm", {
                    message: "Voulez vous vraiment supprimer le questionnaire brouillon'" + questionnaire.label + "' ?",
                    success: () => {

                        tools.loader(true);

                        axios.delete(tools.api("questionnaire/" + questionnaire.id), tools.headerPOST())
                            .then((response) => {
                                if (!tools.isSuccessResponse(response)) {
                                    tools.loader(false);
                                    return tools.popup("valid", {
                                        title: "Erreur",
                                        message: "Erreur lors de la suppression du questionnaire.",
                                    });
                                }

                                this.load();
                            })
                            .catch((error) => {
                                tools.loader(false);
                                tools.popup("valid", {
                                    title: "Erreur",
                                    message: "Erreur lors de la suppression du questionnaire. <br/><br/>Détail de l'erreur : <br/>" + tools.parseError(error)
                                })
                            })
                    }
                })
            },
            active(questionnaire, $event) {

                let active = $event.target.checked;
                let update = {};

                if (active) {
                    questionnaire.active = '1';
                    this.questionnaires.map((quest) => {
                        if (questionnaire.reason.id === quest.reason.id && quest.id !== questionnaire.id) {
                            quest.active = '0';
                        }
                    })
                } else {
                    questionnaire.active = '0';
                }

                this.questionnaires.map((quest) => {
                    update["questionnaire_" + quest.id] = quest.active === '1' ? 1 : 0;
                });

                clearTimeout(this.timeOut);

                this.timeOut = setTimeout(() => {

                    axios.post(tools.api("questionnaires/active"), tools.toPOST(update), tools.headerPOST())
                        .then((response) => {
                            if (!tools.isSuccessResponse(response)) {
                                return tools.popup("valid", {
                                    title: "Erreur",
                                    message: "Erreur lors de l'activation du questionnaire",
                                });
                            }
                        })
                        .catch((error) => {
                            tools.popup("valid", {
                                title: "Erreur",
                                message: "Erreur lors de l'activation du questionnaire. <br/><br/>Détail de l'erreur : <br/>" + tools.parseError(error)
                            })
                        })
                }, 1000)


            },
            limitChange(limit) {
                this.limit = limit;
                this.currentPage = 0;

                tools.saveCookies("questionnaires", this);
            },
            pageChange(page) {
                this.currentPage = page;

                tools.saveLocals("questionnaires", this);
            },
            changeOrder(data) {
                this.order = {
                    order: data.order,
                    name: data.name
                }
                tools.saveLocals("questionnaires", this);
            },
            state(state) {
                switch (state) {
                    case "-1" :
                        return "Brouillon";
                        break;
                    case "1" :
                        return "Publié";
                        break;
                }
            },
            onSelectCustomer(items) {
                this.customersSelect = items;
            },
            onSelectReason(items) {
                this.reasonsSelect = items;
            },
            resetSearch() {
                this.customersSelect = [];
                this.reasonsSelect = [];
            },
            search(filter) {
                this.filter = filter;
                tools.saveLocals("questionnaires", this);
            },
        },
        computed: {
            filters() {

                let questionnaires = this.questionnaires;

                if(this.customerId > 0 && this.filter){
                    let reg = new RegExp(this.filter, "i");
                    questionnaires = questionnaires.filter((questionnaire) => reg.exec(questionnaire.label) || reg.exec(questionnaire.customer.company) || reg.exec(questionnaire.reason.label))
                }

                if(this.customersSelect.length > 0 || this.reasonsSelect.length > 0) {
                    questionnaires = questionnaires.filter((questionnaire) => this.customersSelect.includes(questionnaire.customer.id) || this.reasonsSelect.includes(questionnaire.reason.id))
                }

                tools.sortArray(questionnaires, this.order);

                return questionnaires;
            },
            visibles() {
                return this.filters.slice(this.currentPage * this.limit, (this.currentPage * this.limit) + parseInt(this.limit));
            }
        },
        mounted() {
            if (!this.$store.getters.hasPerm('questionnaire:list')) {
                return this.$router.back();
            }

            this.customerId = this.$route.params.customer_id;

            tools.setLocals("questionnaires", this);
            tools.setCookies("questionnaires", this);

            tools.$emit("orderChange", this.order);

            tools.loader(true);

            this.$store.commit("onEditMode", false);

            if(this.customerId > 0) {
                this.loadByCustomer();
            }else{
                this.loadAll();
            }
        }
    }
</script>
